"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateMiddleAngle = function (startAngle, endAngle) {
    return startAngle + (endAngle - startAngle) / 2;
};
